module.exports = __webpack_public_path__ + "img/github-brands.4b199791.svg";